@if (canReorder) {
  <div #dragRef class="flex">
    <mat-icon class="cursor-pointer drag-indicator">drag_indicator</mat-icon>
  </div>
}

@if (isReordered) {
  <mat-icon class="drag-indicator">swap_vert</mat-icon>
}
